/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 * @param a
 * @param n
 */
/// ////////////////////////////////////////////////////////////////////
// Helper functions with common math calculations
/// ////////////////////////////////////////////////////////////////////

// Modulo which always returns a positive number between 0 and n but
// throws an error if n === 0
export function mod(a: number, n: number) {
  if (n === 0) {
    throw new Error("Can't divide by zero");
  }

  return ((a % n) + n) % n;
}
